import { primatooRevision } from './primatoo-revision';
import { BrowserOptions, httpClientIntegration, rewriteFramesIntegration } from '@sentry/angular';

type SentryProjectsName = 'primatoo-ui' | 'primatoo-ui-console'

enum SentryEnvironments {
  production = 'production',
  develop = 'develop',
  quality = 'quality',
  staging = 'staging'
}

const rev = primatooRevision.toLowerCase();

let envName = SentryEnvironments.production;
console.log("1 envName="+envName)

if (rev.includes('dev')) envName = SentryEnvironments.develop;
if (rev.includes('qa')) envName = SentryEnvironments.quality;
if (rev.includes('staging')) envName = SentryEnvironments.staging;

console.log("2 envName="+envName)

const sentryEnabledIn = [
  SentryEnvironments.quality,
  SentryEnvironments.staging,
  SentryEnvironments.production
]

// Compose a Sentry release name that ties the UI build to the exact revision and project
const buildReleaseName =
  (projectName: SentryProjectsName) => `${primatooRevision}-${projectName}`;

console.log("enabled="+sentryEnabledIn.includes(envName))

export class SentryConfigurator {

  public static buildBrowserConfig(options: {
    sentryProjectName: SentryProjectsName, dsn: string
  }): BrowserOptions {
    const releaseName = buildReleaseName(options.sentryProjectName);
    console.log("releaseName="+ releaseName)
    return {
      enabled: sentryEnabledIn.includes(envName),
      environment: envName,
      dsn: options.dsn,
      integrations: [
        rewriteFramesIntegration(),
        httpClientIntegration({
          failedRequestStatusCodes: [400, 412, 423, 500]
        })
      ],
      release: releaseName,
      tracesSampleRate: 1
    };
  }
}
